import Image from 'components/LegacyImage'
import styles from './NameplateImage.module.scss'

type NameplateImageProps = {
  alt?: string
  sizes?: string
  src: string
}

const NameplateImage = ({ alt, sizes, src }: NameplateImageProps) => (
  <div className={styles.container}>
    <Image
      alt={alt}
      className={styles.image}
      layout='fill'
      sizes={sizes}
      src={src}
    />
  </div>
)

export default NameplateImage
